import { Component, Input, OnInit } from '@angular/core'
import { User } from '../../../common/interfaces/user.interface'
import { environment } from '../../../../environments/environment'
import { ResourceService } from '../../../common/services/resource.service'
import { Role } from '../../../common/enums/role.enum'
import { AuthService } from '../../../common/services/auth.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-user-table',
  templateUrl: './user-table.component.html',
  styleUrls: ['./user-table.component.scss'],
  providers: [ResourceService]
})
export class UserTableComponent implements OnInit {
  @Input() users: User[]

  Role = Role
  userToDelete: User
  storagePath: string = environment.storagePath
  currentUser: User

  constructor(
    private resourceService: ResourceService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authService.currentUser.subscribe((userRes: User) => {
      this.currentUser = userRes
    })
  }

  toggleActive(user: User) {
    this.resourceService
      .patch('users', user.id, 'toggle-active', new FormData())
      .subscribe(() => {
        user.active = !user.active
      })
  }

  delete(user: User): void {
    this.userToDelete = user
  }

  onDeleteCanceled() {
    delete this.userToDelete
  }

  navigateToEditUser(user: User) {
    if (this.currentUser.role === Role.Admin || user.role !== Role.Admin) {
      this.router.navigate(['/users', user.id, 'edit'])
    }
  }
}
